import { Component, OnInit, Input } from '@angular/core';
import { PlayerViewModel } from '../../../shared/models/player.model';

import { SCGameLineUpPlayer } from '../../../shared/models/GameModels';


@Component({
    selector: 'app-lineup-player-card',
    imports: [],
    templateUrl: './lineup-player-card.component.html',
    styleUrls: ['./lineup-player-card.component.css']
})
export class LineupPlayerCardComponent implements OnInit {


  @Input() Player?: SCGameLineUpPlayer;
  constructor() { }

  ngOnInit() {
    //console.log(this.Player[0].PlayerLastName);
  }

  navigate(playerid:string){
    // console.log(playerid);
  }

}
